import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomTooltipDirection } from '../../custom-tooltip/custom-tooltip';

@Component({
  selector: 'ps-ui-aida-info-tooltip',
  template: `
    <ps-ui-custom-tooltip [direction]="direction">
      <i
        psUiTooltipTarget
        class="fa fa-info-circle text-primary"
        aria-hidden="true"
      ></i>

      <div psUiTooltipContent class="text-white">
        <p class="fw-bolder">Benefits of AIDA&#8482;:</p>
        <ul>
          <li>
            Automatically gathers high-quality responses within your set
            timeframe
          </li>
          <li>Minimises manual tracking and management</li>
          <li>Lets you focus on other tasks while we handle the fielding</li>
        </ul>
      </div>
    </ps-ui-custom-tooltip>
  `,
  styles: ['i { font-size: 20px; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AidaInfoTooltipComponent {
  @Input()
  public direction: CustomTooltipDirection = 'right';
}
